export const PIXEL_ATTRIBUTE_KEYS_V97 = [
  'long_edge_min_px',
  'long_edge_max_px',
];

export const validateImagePixelsV97 = (components, t) => {
  const ranges = [];
  for (const component of components) {
    if (component.meter !== 'image') continue;
    const attrs = component.attributes || {};
    const bounds = {};
    for (const key of PIXEL_ATTRIBUTE_KEYS_V97) {
      const value = String(attrs[key] ?? '').trim();
      if (!value) continue;
      if (!/^\d+$/.test(value) || Number(value) < 1 || Number(value) > 1000000)
        return t('models.commercial.errors.pixel_integer');
      bounds[key] = Number(value);
    }
    if (Object.keys(bounds).length === 0) continue;
    const min = bounds.long_edge_min_px || 1;
    const max = bounds.long_edge_max_px || 1000000;
    if (max < min) return t('models.commercial.errors.pixel_order');
    const tier = String(attrs.service_tier || 'standard')
      .trim()
      .toLowerCase();
    for (const previous of ranges) {
      const qualifiersOverlap = [
        'size',
        'quality',
        'resolution',
        'aspect_ratio',
      ].every((key) => {
        const normalize = (value) =>
          key === 'resolution' ? value.toLowerCase() : value;
        const a = normalize(String(attrs[key] || '').trim());
        const b = normalize(String(previous.attrs[key] || '').trim());
        return !a || !b || a === b;
      });
      if (
        tier === previous.tier &&
        qualifiersOverlap &&
        min <= previous.max &&
        previous.min <= max
      )
        return t('models.commercial.errors.pixel_overlap');
    }
    ranges.push({ min, max, tier, attrs });
  }
  return '';
};

export const formatImagePixelsV97 = (items, unknown = 'Unknown') =>
  Array.isArray(items) && items.length > 0
    ? items
        .map((item, index) => {
          const known =
            item?.status === 'measured' &&
            Number.isInteger(item.width) &&
            item.width > 0 &&
            item.width <= 1000000 &&
            Number.isInteger(item.height) &&
            item.height > 0 &&
            item.height <= 1000000;
          return `#${index + 1}: ${
            known ? `${item.width} x ${item.height} px` : unknown
          }`;
        })
        .join('; ')
    : unknown;

export const imagePixelAttributesV97 = (raw) => {
  try {
    return JSON.parse(raw || '{}').image_dimensions_v97;
  } catch {
    return undefined;
  }
};
